import { ReturnOverviewEffect } from './return-overview.effect';
import { ReturnDetailsEffect } from './return-details.effect';

export const effects: any[] = [
  ReturnOverviewEffect,
  ReturnDetailsEffect,
];
